export default __webpack_public_path__ + "icon-sale.fa829175e413177b214b931c60761a82.svg";